import api from './api';

// Obtener todos los usuarios
const getUsers = async () => {
  const response = await api.get('/api/users');
  return response.data;
};

// Obtener un usuario por ID
const getUserById = async (id) => {
  const response = await api.get(`/api/users/${id}`);
  return response.data;
};

// Crear un nuevo usuario
const createUser = async (userData) => {
  const response = await api.post('/api/users', userData);
  return response.data;
};

// Actualizar un usuario
const updateUser = async (id, userData) => {
  const response = await api.put(`/api/users/${id}`, userData);
  return response.data;
};

// Eliminar un usuario
const deleteUser = async (id) => {
  const response = await api.delete(`/api/users/${id}`);
  return response.data;
};

const userService = {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser
};

export default userService; 